
import React from 'react';
import SignUp from '../../../components/Registration/SignUp/SignUp';
import './SignUpPage.css';
const SignUpPage = () => {

  return (
   <div>
   
      <SignUp/>
    </div>
  );
};

export default SignUpPage;

